import React from 'react'

const Newsletter = () => {
  return (
    <section className='flex justify-center items-center font-basis text-center text-azul font-bold mt-28'>
      <div className='block'>
        <h4 className='text-2xl mb-4'>Sign up for exclusive offers</h4>
        <form>
          <input className='ml-5 bg-secundaria outline-none border-b-2 border-azul placeholder-azul font-bold' placeholder='Email' />
          <button className='ml-0 px-2  uppercase font-bold tracking-widest text-xs'> Subscribe &#62;</button>
        </form>
      </div>
    </section>
  )
}

export default Newsletter
